import React from 'react'

export const Footer: React.FC = () => {
  return (
    <>
      <div className="bg-base-color">
        <div className="pt-6 w-11/12 pc:w-1/2 mx-auto">
          <div className="pc:flex text-xs text-center justify-center mx-auto pc:text-gray-50 text-gray-70">
            <div className="pc:mr-8">
              <a
                className="font-bold"
                target="_blank"
                rel="noreferrer"
                href="https://medicalnote.jp/terms"
              >
                ご利用規約
              </a>
            </div>
            <div className="pc:ml-8 pt-4 pc:pt-0">
              <a
                className="font-bold"
                target="_blank"
                rel="noreferrer"
                href="https://medicalnote.co.jp/privacy"
              >
                プライバシーポリシー
              </a>
            </div>
          </div>
          <div className="mt-8 mx-2 pt-8 pc:mx-0 text-xs border-t border-gray-30 text-gray-60 text-left pc:text-center">
            本サービスにおける医師・医療従事者などによる情報の提供は診断・治療行為ではありません。
            <br />
            診断・治療を必要とする方は、必ず適切な医療機関を受診してください。
            <br />
            本サービス上の情報や利用に関して発生した損害などに関して、弊社は一切の責任を負いかねます。
          </div>
          <div className="py-8 text-xs text-center text-gray-50">
            © MedicalNote, Inc. All Rights Reserved.
          </div>
        </div>
      </div>
    </>
  )
}
